module.exports = __webpack_public_path__ + "img/临床监察员.77e4e3cf.jpg";